import { render, staticRenderFns } from "./Page06Sub.vue?vue&type=template&id=a2005ca0&scoped=true&"
import script from "./Page06Sub.vue?vue&type=script&lang=js&"
export * from "./Page06Sub.vue?vue&type=script&lang=js&"
import style0 from "./Page06Sub.vue?vue&type=style&index=0&id=a2005ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2005ca0",
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QTooltip,QList,QItem,QItemSection,QChip,QBadge,QScrollArea,Ripple} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QSeparator,QTooltip,QList,QItem,QItemSection,QChip,QBadge,QScrollArea}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
